import React from "react";
import {findDOMNode} from 'react-dom';
import Link from 'gatsby-link';
import classnames from 'classnames';
import keyBy from 'lodash/keyBy';
import {Manager, Target, Popper, Arrow} from 'react-popper';
import Logo from '../logo.png';
import './Header.css';
import {gotoSignup} from '../utils/ga';
import Button from '../components/Button';
import './Header.css';
import AndroidIcon from './android.svgc';
import JSIcon from './js.svgc';


class Header extends React.Component {
  render() {
    const {showLogo, selectedPlatform} = this.props;

    return <div className="Header">
      {showLogo && <Link to="/index" className="Header-Logo"><img src={Logo} /></Link>}

      <Selector
        style={{marginLeft: '10px'}}
        selectedPlatform={selectedPlatform}
      />

      <ul>
        <li><Link to={'/docs'}>Documentation</Link></li>
        <li><Link to={'/pricing'}>Pricing</Link></li>
        <li><a href={"https://app.bundlecop.com"}>Login</a></li>
        <li><Button onClick={gotoSignup}>Signup</Button></li>
      </ul>
    </div>
  }
}

Header.propTypes = {
  showLogo: React.PropTypes.bool
}

Header.defaultProps = {
  showLogo: true
}

export default Header;


// TODO: react-pverlays didn't postion correctly, but once they
// start using popper it might be nice because it gives us an animation
// for free.
class Selector extends React.Component {

  static propTypes = {
    selectedPlatform: React.PropTypes.string
  }

  state = {
    isOpen: false
  };

  render() {
    const platforms = [
      {
        id: 'android',
        icon: AndroidIcon,
        label: 'Android'
      },
      {
        id: 'js',
        url: '/',
        icon: JSIcon,
        label: 'JavaScript'
      },
    ];

    const byId = keyBy(platforms, 'id');

    let CurrentIcon;
    const platform = byId[this.props.selectedPlatform];
    if (platform) {
      CurrentIcon = platform.icon;
    }

    return  <Manager className="TechSelector">
      <Target>
        <a
          href=""
          onClick={this.handleClick}
          style={this.props.style}
          className={classnames("TechSelector-Link", platform && "TechSelector-Link--platform" )}
        >
          {!platform ? "Platforms" : <span>
            <CurrentIcon /> {platform.label}
          </span>}
        </a>
      </Target>
      {this.state.isOpen &&
        <Popper placement="bottom" className="Popper TechSelector-Popup">
          {platforms.map(({icon: Icon, label, url, id}) => {
            return <Link key={id} to={url || `/${id}`}>
              <Icon /> {label}
            </Link>
          })}

          <Arrow className="Popper-arrow"/>
      </Popper>}
    </Manager>
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({isOpen: !this.state.isOpen});
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Header.js